module.exports = __webpack_public_path__ + "assets/print-btn-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/print-btn-icon.svg
// module id = 815
// module chunks = 0